import React, { useRef, useState } from 'react'

import InputText from '../input-text/input-text'
import inputProptypes from '../input-proptype'
import * as PhoneNumberUtility from '@components/utilities/phone-number-utility'
import * as BaseFunctions from '../base-functions'

import { useInitialValueToValidation } from '../custom-hooks'
import useEvents from '@components/utilities/event-hooks-utility'

const InputCellPhone = ({ onChange, onBlur, errorMessage, value, onFieldValidation, name, required, ...rest }) => {
  const [currentMessage, setCurrentMessage] = useState(errorMessage)
  const [inputValue, setInputValue] = useState(value || '')
  const [currentName] = useState(BaseFunctions.getInputName(name))

  const thisInput = useRef(null)
  const defaultEvents = useEvents(thisInput)

  const validateCellphone = async (unmaskedCellPhone, maskedCellPhone) => {
    setCurrentMessage('')

    if (!required && !unmaskedCellPhone?.length) return
    if (maskedCellPhone.length !== 15) return setCurrentMessage('O Celular precisa ter 11 dígitos.')

    const numberAfterDirectDistanceDialingIsValid = parseInt(unmaskedCellPhone[2]) === 9
    if (!numberAfterDirectDistanceDialingIsValid) return setCurrentMessage('Número de celular inválido')
  }

  const handleOnChange = defaultEvents.useOnChange(async ({ value, id, name }) => {
    setCurrentMessage('')

    const { maskedCellPhone, unmaskedCellPhone } = PhoneNumberUtility.maskCellphone(value)

    setInputValue(maskedCellPhone)

    if (onChange) await onChange({ value: unmaskedCellPhone, maskedValue: maskedCellPhone, id, name })

    return maskedCellPhone
  })

  const handleOnBlur = value => {
    setCurrentMessage('')
    const { maskedCellPhone, unmaskedCellPhone } = PhoneNumberUtility.maskCellphone(value)

    validateCellphone(unmaskedCellPhone, maskedCellPhone)
    if (onBlur) onBlur(unmaskedCellPhone, maskedCellPhone)
  }

  let inputProps = {
    onChange: handleOnChange,
    onBlur: handleOnBlur,
    errorMessage: currentMessage,
    maxLength: 15,
    value: inputValue,
    onFieldValidation,
    name: currentName,
    inputRef: thisInput,
    onKeyUp: defaultEvents.onKeyUp,
    required,
    type: 'tel',
    ...rest,
  }

  useInitialValueToValidation(value, () => {
    if (!value) return
    const { maskedCellPhone, unmaskedCellPhone } = PhoneNumberUtility.maskCellphone(value)

    setInputValue(maskedCellPhone)
    validateCellphone(unmaskedCellPhone, maskedCellPhone)
  })

  return <InputText {...inputProps} />
}

InputCellPhone.propTypes = inputProptypes

export default InputCellPhone
